module.exports = __webpack_public_path__ + "img/DefaultImage.2fa48b9c.svg";